import { render, staticRenderFns } from "./GoogleReview.vue?vue&type=template&id=736679b6"
import script from "./GoogleReview.vue?vue&type=script&lang=js"
export * from "./GoogleReview.vue?vue&type=script&lang=js"
import style0 from "./GoogleReview.vue?vue&type=style&index=0&id=736679b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports